import * as type from './action-types';
import moment from 'moment';

export const initialState = {
  dateFilter: {
    startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    error: false
  }
};

export function changeDate (state = initialState, action) {
  switch (action.type) {
    case type.CHANGE_START_DATE:
      return Object.assign({}, state.dateFilter, {
        startDate: action.payload,
        error: !validateDate(action.payload, state.dateFilter.endDate)
      });

    case type.CHANGE_END_DATE:
      return Object.assign({}, state.dateFilter, {
        endDate: action.payload,
        error: !validateDate(state.dateFilter.startDate, action.payload)
      });

    default:
      return state;
  }
};

function validateDate (start, end) {
  return start && end && start <= end;
}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/datepicker-range/reducer.js
 **/